import { HttpErrorResponse, type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { catchError, throwError } from 'rxjs';

import { isSessionRevokedBody, SessionRevokedService } from '@core/services/session-revoked.service';

import { environment } from '@environments/environment';

/**
 * Reacts to `401 { error: 'session_revoked' }` from the API by showing the "Sitzung beendet" notice
 * and logging out, instead of any re-login redirect (that would sign the user straight back in).
 * The error is still re-thrown so the failing caller stops normally.
 */
export const sessionRevokedInterceptor: HttpInterceptorFn = (req, next) => {
  const sessionRevoked = inject(SessionRevokedService);
  if (!req.url.startsWith(environment.apiBaseUrl)) {
    return next(req);
  }

  return next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse && err.status === 401 && isSessionRevokedBody(err.error)) {
        sessionRevoked.handle();
      }
      return throwError(() => err);
    }),
  );
};
